var render = function () {
var _obj;
var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (!(_vm.disabled || _vm.blocked))?_c('a',{class:_vm.$style.action,attrs:{"href":"#"},on:{"click":function($event){$event.preventDefault();return _vm.$emit('click')}}},[_vm._t("default")],2):_c('span',{class:( _obj = {}, _obj[_vm.$style.action] = true, _obj[_vm.$style.disabled] = _vm.disabled, _obj[_vm.$style.blocked] = _vm.blocked, _obj )},[_vm._t("default")],2)}
var staticRenderFns = []

export { render, staticRenderFns }